module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-bg-1-2f1a65f6b10d4b31fe56ffacdb748890.png";